import { FETCH_POSTS, NEW_POSTS, FETCH_LOADTRUCKS, FETCH_LOC } from '../actions/actionTypes';

const initialState = {
    items_fetchLoadTrucks: [],
    items: [],
    item: {},
    items_fetchLoc: [],
  
}

const postReducer = (state = initialState, action) => {
    switch(action.type){
        case FETCH_POSTS:
            console.log("FETCH_POSTS");
            return {
                ...state,
                items: action.payload
            }
        case NEW_POSTS: 
            console.log("NEW_POSTS");           
            return {
                ...state,
                items: [action.payload, ...state.items]
            }
        case FETCH_LOADTRUCKS: 
            console.log("FETCH_LOADTRUCKS");           
            return {
                ...state,
                items_fetchLoadTrucks: action.payload
            } 
        case FETCH_LOC:
            console.log("FETCH_LOC");       
            return {
                ...state,
                items_fetchLoc: action.payload
            }                                               
        default:
            return state;
    }
}

export { postReducer };